<template>
  <div class="edit-form">
    <h3 class="edit-header">
      <div class="edit-header-title"><span>[ID:{{ id }}] / [PATH:{{ path }}]</span></div>
      <div class="edit-header-ops">
        <span
          class="view-btn el-icon-warning-outline"
          @click="tipVisible = !tipVisible"
        >
          提示
        </span>
        <span
          v-show="id"
          class="view-btn el-icon-upload"
          @click="onUpdate"
        >
          更新
        </span>
        <span
          class="view-btn el-icon-view"
          @click="onSave"
        >
          预览
        </span>
        <span
          class="view-btn el-icon-close"
          @click="close"
        >
          关闭
        </span>
      </div>
    </h3>
    <div
      v-show="tipVisible"
      class="edit-tips"
    >
      <div class="edit-tip-item">
        <p class="edit-tip-item-title">外部参数</p>
        <p class="edit-tip-item-desc">[Object] query: 页面地址参数</p>
        <p class="edit-tip-item-desc">[String] env: 当前环境</p>
        <p class="edit-tip-item-desc">[Function] checkPerm: 权限检查 @return[Boolean]</p>
      </div>
      <div class="edit-tip-item">
        <p class="edit-tip-item-title">开发注意事项</p>
        <p class="edit-tip-item-desc">1. 须准确的json格式。（配置中不能使用Function类型的adaptor）</p>
        <p class="edit-tip-item-desc">2. api直接写路径。（eg: 'api': '/user/list'）</p>
        <p class="edit-tip-item-desc">
          <a
            href="https://baidu.github.io/amis/docs/api#%E5%85%B7%E4%BD%93%E8%A6%81%E6%B1%82"
            target="_blank"
          >
            3. api/response data字段需按要求格式返回。
          </a>
        </p>
        <p class="edit-tip-item-desc">
          <a
            href="https://fontawesome.com/v4.7.0/"
            target="_blank"
          >
            4. icon仅可使用 fontawesome-v4.7.0版本
          </a>
        </p>
        <p class="edit-tip-item-desc">
          5. 权限控制实例："visibleOn": "checkPerm('xPermName')"
        </p>
        <p class="edit-tip-item-desc">
          6. 可通过service复用json配置,如：{ "type": "service", "schemaApi": "get:/site/config?path=xxx" }
        </p>
      </div>
    </div>
    <div
      v-if="display"
      class="edit-content"
    >
      <crm-json-editor
        ref="editor"
        :json="json"
        :editable="true"
        height="100%"
        @error="e => error = e"
      />
    </div>
  </div>
</template>

<script>
import JsonEditor from './JsonEditor';
import QuRequest from '../core/QuRequest';

const Q = new QuRequest();

export default {
  name: 'AmisEditor',
  components: {
    'crm-json-editor': JsonEditor,
  },
  props: {
    visible: { type: Boolean, default: false },
    id: { type: [String, Number], default: '' },
    path: { type: String, default: '' },
    json: {
      type: [String, Number, Object, Array],
      default: '',
    },
  },
  data() {
    return {
      error: null,
      tipVisible: false,
    };
  },
  computed: {
    display: {
      get: function() {
        return this.visible;
      },
      set: function(v) {
        this.$emit('visible', v);
      },
    },
  },
  methods: {
    close() {
      this.display = false;
    },
    validate() {
      if (this.error) {
        this.$message.error('当前json格式有误');
        return false;
      } else {
        return true;
      }
    },
    onSave() {
      if (!this.validate()) return;

      const value = this.$refs.editor.getValue();
      this.$emit('change', value);
    },
    async onUpdate() {
      if (!this.validate()) return;
      const value = this.$refs.editor.getValue();

      try {
        await this.$confirm(
          `即将上传当前json覆盖[id:${this.id}/path:${this.path}]配置, 是否继续?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );

        await Q.send(Q.Apis.sales.amis.updateJson, {
          id: this.id,
          content: JSON.stringify(value || {}),
        });

        this.$message.success('更新成功');
        this.$emit('change', value);
      } catch {}
    },
  },
};
</script>
<style lang="less" scoped>
.edit-form {
  display: flex;
  flex-flow: column nowrap;
  background: #3983fa;
  height: 100%;
  .edit-header {
    flex-shrink: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 16px;
    font-size: 14px;
    color: #fff;
    background: #1f65d6;
    margin: 0;

    .edit-header-title {
      flex-shrink: 0;
    }
    .edit-header-ops {
      flex: 1;
      text-align: right;
      .view-btn {
        color: #fff;
        font-size: 14px;
        margin-right: 24px;
        cursor: pointer;
        user-select: none;

        &:hover {
          font-weight: bolder;
        }
      }
    }
  }
  .edit-tips {
    flex-shrink: 1;
    background: #353535;
    border-top: 1px solid #1b5bc1;
    padding: 0 12px 12px 12px;
    .edit-tip-item {
      margin-top: 12px;
      p {
        margin: 0;
      }
      p.edit-tip-item-title {
        font-size: 12px;
        padding-left: 6px;
        margin-bottom: 8px;
        color: #fff;
        font-weight: bolder;
        border-left: 10px solid #fff;
      }
      .edit-tip-item-desc {
        font-size: 12px;
        color: #fff;
        font-weight: 500;
        line-height: 18px;
        a {
          font-size: 12px;
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }
  .edit-content {
    flex: 1;
  }
}
</style>